export const resolveDate = value => {
  if (value === null) {
    return null
  }
  const date = new Date(value)
  return isNaN(date) ? null : date
}

export const formatCsvDate = value => {
  const date = resolveDate(value)
  const pad = n => String(n < 10 ? `0${n}` : n)

  if (!date) { return '' }

  const yyyy = date.getFullYear()
  const mm = pad(date.getMonth() + 1)
  const dd = pad(date.getDate())
  return [yyyy, mm, dd].join('-')
}

export const indicatorsToCsv = data => {
  const headers = [
    'Indicator Value',
    'Indicator Type',
    'IC Score',
    'Associated Actors',
    'Associated Malware',
    'Associated Tools',
    'Associated Campaigns',
    'Exclusive',
    'First Seen',
    'Last Seen',
  ].join(',')

  const escapeCol = value => `'${String(value).replace(/'/g, "''")}'`

  const mapAssociations = (associations = []) => {
    const map = associations.reduce((acc, item) => {
      acc[item.type] || (acc[item.type] = [])
      acc[item.type].push(item)
      return acc
    }, {})

    return {
      get: type => {
        return Array.isArray(map[type])
          ? map[type].map(item => item.name).join(', ')
          : ''
      }
    }
  }

  const rows = (data?.objects || []).map(({
    type = '',
    value = '',
    mscore = '',
    attributed_associations: attributedAssociations = [],
    first_seen: firstSeen,
    last_seen: lastSeen,
    is_exclusive: isExclusive = false,
  }) => {
    const associations = mapAssociations(attributedAssociations)

    return [
      value,
      type.toUpperCase(),
      mscore,
      associations.get('threat-actor'),
      associations.get('malware'),
      associations.get('tool'),
      associations.get('campaign'),
      isExclusive ? 'True' : 'False',
      formatCsvDate(firstSeen),
      formatCsvDate(lastSeen),
    ].map(escapeCol).join(',')
  })

  rows.unshift(headers)

  return rows.join('\n')
}
